export const researchPublications = [
  {
    id: 1,
    title: 'Impacts of Syntactic Complexity on Model Robustness',
    description:
      'Studies how increased syntactic complexity impacts NLP performance in NLI tasks by evaluating four model architectures on the MultiNLI dataset and its perturbed versions. Results show only small accuracy drops, suggesting that complex, pre-trained models generalize well even under higher syntactic complexity.',
    summary: 'New publication on robustness trends in NLI models under syntactic perturbations.',
    tags: ['NLP', 'NLI'],
    pdf: '/research/Syntactic_Complexity_and_Model_Robustness.pdf',
    year: 2026,
  },
  {
    id: 2,
    title: 'Development of a Novel Foundation Prior for Physics-Informed Reinforcement Learning',
    description:
      'This project develops a physics-informed foundation prior using a U-Net trained on fluid simulations. Using this prior improves reinforcement learning performance and training efficiency on physics-based tasks.',
    summary: 'Physics-informed U-Net prior improves reinforcement learning performance and training efficiency.',
    tags: ['PIRL', 'CNN', 'RL'],
    pdf: '/research/Development_of_Novel_Foundation_Prior_PIRL.pdf',
    year: 2025,
  },
];

export const latestResearchPublication = researchPublications.reduce(
  (latest, publication) => {
    if (!latest) {
      return publication;
    }

    if (publication.year > latest.year) {
      return publication;
    }

    if (publication.year === latest.year && publication.id > latest.id) {
      return publication;
    }

    return latest;
  },
  null
);
